import { Z_INDEX } from "@/style/zIndex";
import { css, Interpolation, Theme } from "@emotion/react";

import { useTabs } from "@/hooks/useTabs";

export type TabProps<T extends string> = Omit<ReturnType<typeof useTabs<T>>, "tabs"> & { tab: T };

type TabsProps<T extends string> = ReturnType<typeof useTabs<T>> & {
  TabComp: React.ComponentType<TabProps<T>>;
  fullWidth?: boolean;
  containerStyles?: Interpolation<Theme>;
};

export function Tabs<T extends string>({ tabs, curTab, selectTab, TabComp, fullWidth = true, containerStyles }: TabsProps<T>) {
  return (
    <div
      css={[
        containerStyles,
        css`
          display: ${fullWidth ? "flex" : "block"};
          position: sticky;
          top: 0;
          background-color: var(--parent-bg-color);
          z-index: ${Z_INDEX.localOverlay};
        `,
      ]}
    >
      {tabs.map((tab, index) => {
        return <TabComp key={index} selectTab={selectTab} curTab={curTab} tab={tab} />;
      })}
    </div>
  );
}
